import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { useSelector } from "react-redux";

import { containerStyles, titleStyles } from "./styles/Header.styles";
import { AppState } from "../store/definitions";

export const Header = ({ customTitle }: { customTitle?: string }) => {
    const { componentProps } = useSelector((state: AppState) => state.config);
    return (
        <Box as="header" className="twilio__header" {...containerStyles}>
            {componentProps?.MainHeader?.imageUrl ? (
                <>
                    <img src={componentProps?.MainHeader?.imageUrl} alt="chat icon" />{" "}
                </>
            ) : (
                ""
            )}
            <Text as="h2" {...titleStyles} element="HEADER__TITLE">
                {componentProps?.MainHeader?.titleText ?? customTitle ?? "Live Chat"}
            </Text>
        </Box>
    );
};
